import { Component, OnInit, OnDestroy, NgZone, ViewChild } from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {
  AuthorizationService,
  EventSubscriptionService,
  EventGroup,
  ModelService,
  Model,
  ClassificationService,
  Classification,
  ToastrService,
} from "./../../../../shared/index";

@Component({
  selector: "model-manipulate",
  templateUrl: "./model-manipulate.html",
  standalone: false,
})
export class ModelManipulateComponent implements OnInit, OnDestroy {
  @ViewChild("modelManipulate") modal: ModalDirective;
  public model: Model = new Model();
  public classifications: Classification[] = [];
  public edit = true;

  private subscriptions: Subscription[] = [];

  constructor(
    private _ngZone: NgZone,
    private _modelService: ModelService,
    private _classificationService: ClassificationService,
    private _eventService: EventSubscriptionService,
    private _toastrService: ToastrService
  ) {
    //this._eventService.configure(this)
    //    .Add(this._classificationService.classificationChange.subscribe((info: any) => this.onClassificationChange(info)))
    //    .Add(this._modelService.manipulateModel.subscribe((info: any) => this.onManipulateModel(info)))
    this.subscriptions.push(
      this._classificationService.classificationChange.subscribe((info: any) =>
        this.onClassificationChange(info)
      )
    );
    this.subscriptions.push(
      this._modelService.manipulateModel.subscribe((info: any) =>
        this.onManipulateModel(info)
      )
    );
  }

  public close() {
    //this._modelService.getFilteredModels();
    this.modal.hide();
  }

  public save(another: boolean = false) {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    if (this.edit) {
      this._modelService.save(this.model);
    } else {
      this._modelService.create(this.model);
      this.model = new Model();
      this.model.ClassificationId = "";
    }
    if (!another) {
      this.modal.hide();
    }
  }

  private onManipulateModel(model: Model): void {
    this.model = model;
    this.edit = model.Id != 0;
    this.modal.show();
  }

  private onClassificationChange(classifications: Classification[]): void {
    //this._ngZone.run(() => {
    this.classifications = classifications;
    //});
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }
}
